export default __webpack_public_path__ + "static/media/set_6_Video-5.bb5aa9ee.svg";